import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import useTheme from 'branding/theme';
import Logo from 'branding/logo';
import Section from '../../layout/Section';
import useComponentMargin from '../../hooks/useComponentMargin';
import useSectionPadding from '../../hooks/useSectionPadding';
import useScrollLock from '../../hooks/useScrollLock';
import useTabTrap from '../../hooks/useTabTrap';
import getBackgroundColor from './getBackgroundColor';
import { mergeRefs } from '../../utils/mergeRefs';
export const SplashView = ({ className, type = 'brand', children, isModal = false, isOpenModal = false, hideLogo = false, noDefaultPadding = false, innerSectionStyles, splashPadding, isCancelable, handleClose, isDrawer = false, styles }) => {
    const { colors, isWebView } = useTheme();
    const logoMargin = useComponentMargin({ marginLeft: 'large', marginTop: 'regular' });
    const wrapperPadding = useSectionPadding({ padding: splashPadding || 'large' });
    const mergedStyles = {
        zIndex: isModal ? 99999 : 88888,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'auto',
        backgroundColor: getBackgroundColor(colors, type),
        boxSizing: 'border-box',
        ...wrapperPadding,
        ...styles
    };
    const logoStyles = useMemo(() => ({
        ...logoMargin,
        ...(isWebView && { marginTop: '4.8rem' }),
        position: 'absolute',
        width: 71,
        height: 22,
        left: 0,
        top: 0
    }), [logoMargin, isWebView]);
    const mergedInnerSectionStyles = useMemo(() => ({
        position: 'relative',
        ...innerSectionStyles,
        ...(isDrawer
            ? {
                marginTop: 'auto',
                maxHeight: '100%',
                minHeight: '30%',
                overflowY: 'auto',
                width: '100%',
                padding: 0,
                borderTopLeftRadius: '2rem',
                borderTopRightRadius: '2rem',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                transition: 'all 200ms ease-out'
            }
            : { margin: 'auto' })
    }), [innerSectionStyles, isDrawer]);
    const ref = useTabTrap();
    const div = React.useRef(null);
    const handleClick = React.useCallback((event) => isCancelable && div.current === event.target && handleClose && handleClose(), [handleClose, isCancelable]);
    React.useEffect(() => {
        window.addEventListener('click', handleClick);
        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, [handleClick]);
    useScrollLock(!isModal || isOpenModal);
    return isOpenModal || !isModal
        ? createPortal(React.createElement("div", { className: className, ref: mergeRefs(ref, div), role: "dialog", "aria-modal": "true", "data-testid": "splash-view", style: mergedStyles },
            !hideLogo && type !== 'modal' && React.createElement(Logo, { styles: logoStyles }),
            type === 'modal' ? (React.createElement(Section, { noDefaultPadding: noDefaultPadding, styles: mergedInnerSectionStyles }, children)) : (children)), document.body)
        : null;
};
export default SplashView;
//# sourceMappingURL=index.js.map